export default __webpack_public_path__ + "static/media/multiplewindows_light.7c4e5125.svg";